import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: "flex justify-center items-center h-[190px] border border-dashed border-transparent bg-transparent hover:opacity-50 rounded-md px-10 gap-10 border-primary transition cursor-pointer",

    content: "flex flex-col",

    actionGroup: "flex justify-center gap-4",

    previewLogo: "relative w-[270px] h-[70px] mb-5 overflow-hidden",

    uploadArea: "flex gap-5",
  },
  variants: {
    isActive: {
      true: {
        base: "border-dashed border-primary bg-primary-50",
      },
    },
  },
});
